import { useEffect } from "react";

export const useBrowserPageTitle = (title?: string) =>
  useEffect(() => {
    window.document.title = title ? `${title} – Wingspan` : "Wingspan";
  }, [title]);
